"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_copy_to_clipboard_1 = require("react-copy-to-clipboard");
const node_1 = require("domhandler/lib/node");
const Message_1 = require("../message/Message");
const PosaTemplate_1 = __importDefault(require("./PosaTemplate"));
const prop_types_1 = __importDefault(require("prop-types"));
const SuccessHeaderStyled_1 = __importDefault(require("./SuccessHeaderStyled"));
const utils_1 = require("../../utils");
const BonusSection_1 = __importDefault(require("./BonusSection"));
const classnames_1 = __importDefault(require("classnames"));
const SuccessHeader = ({ resetFlow, trackEvent, posaRedeemStore, showBonusSection }) => {
    const { secondaryCode: secondaryCodeObj = {} } = posaRedeemStore;
    const secondaryCode = secondaryCodeObj.code || '';
    const successData = utils_1.getSuccessData(posaRedeemStore);
    const { bonusOffers } = posaRedeemStore;
    const showbonus = showBonusSection && bonusOffers && bonusOffers.length;
    const { bgImage, contentLeftColumn, contentRightColumn, disableStepsButton, visitLink, visitText } = successData;
    const track = react_1.useCallback(() => trackEvent('visitLink', { link: visitLink }), [visitLink]);
    const style = react_1.useMemo(() => ({
        backgroundImage: `url(${bgImage})`
    }), [bgImage]);
    const [copied, setCopyStatus] = react_1.useState(false);
    const onCopy = react_1.useCallback(() => {
        trackEvent('copiedText', {});
        setCopyStatus(true);
    }, [trackEvent]);
    const options = react_1.useMemo(() => ({
        replace: domnode => {
            if (!(domnode instanceof node_1.Element && domnode.attribs))
                return;
            const { attribs } = domnode;
            if (!attribs)
                return;
            if (attribs.class === 'copyToClipboard') {
                return (react_1.default.createElement("li", { className: "center" },
                    react_1.default.createElement("span", { className: "circle" }, "3"),
                    react_1.default.createElement(react_copy_to_clipboard_1.CopyToClipboard, { text: secondaryCode, onCopy: onCopy },
                        react_1.default.createElement("button", { className: `ecrs-button ecrs-copyToClipboard` }, Message_1.localizedMessage('epic.code.redemption.posa.copyToClipboard'))),
                    react_1.default.createElement("span", { className: `ecrs-copiedText ${copied ? 'copied' : ''}` }, Message_1.localizedMessage('epic.code.redemption.posa.copied'))));
            }
            if (attribs.class === 'visitLink' && !disableStepsButton) {
                return (react_1.default.createElement("li", { className: "center" },
                    react_1.default.createElement("span", { className: "circle" }, "4"),
                    react_1.default.createElement("a", { className: "ecrs-button", onClick: track, href: visitLink, target: "_blank", rel: "noopener noreferrer" }, visitText)));
            }
            if (attribs.class === 'btn btn-primary centered restart') {
                const value = Message_1.localizedMessage('epic.code.redemption.othercard');
                return (react_1.default.createElement("button", { className: "btn btn-primary centered", onClick: resetFlow }, value));
            }
        }
    }), [trackEvent, resetFlow, secondaryCode, onCopy, disableStepsButton, visitLink, track, visitText]);
    return (react_1.default.createElement(SuccessHeaderStyled_1.default, { className: "ecr-success-header", style: style },
        react_1.default.createElement("div", { className: "ecr-success-header-wrapper" },
            react_1.default.createElement("div", { className: classnames_1.default('ecrs-content', { 'with-bonus': showbonus }) },
                react_1.default.createElement(BonusSection_1.default, { show: showBonusSection, bonusOffers: bonusOffers, header: "epic.code.redemption.posa.page.redeem.confirm.reward.acquired.title", subtitle: "", notice: "epic.code.redemption.posa.page.redeem.confirm.reward.acquired.apply" }),
                react_1.default.createElement(PosaTemplate_1.default, { Tag: "div", isTemplate: true, className: "left-part", string: contentLeftColumn, posaRedeemStore: posaRedeemStore }),
                react_1.default.createElement(PosaTemplate_1.default, { Tag: "div", isTemplate: true, className: "right-part", string: contentRightColumn, posaRedeemStore: posaRedeemStore, options: options })))));
};
SuccessHeader.propTypes = {
    posaRedeemStore: prop_types_1.default.object,
    resetFlow: prop_types_1.default.func,
    trackEvent: prop_types_1.default.func,
    showBonusSection: prop_types_1.default.bool
};
exports.default = SuccessHeader;
//# sourceMappingURL=SuccessHeader.js.map